import { Grid, styled, Theme } from "@mui/material";

export const DashboardGrid = styled(Grid)(({ theme }: { theme: Theme }) => ({
  ".divider": {
    borderBottom: "2px solid",
    color: theme.palette.common.white,
    width: "12rem",
    paddingTop: "1.25rem",
    marginBottom: "2.5rem",
  },
  ".grid-card": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "14rem",
    padding: "2.5rem 4rem",
    textAlign: "center",
    a: {
      marginTop: "auto",
    },
    h2: {
      marginBottom: "0.5rem",
    },
  },
  ".grid-tooltip-card__inner": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "start",
    gap: "1rem",
    padding: "2rem 0",
  },
}));
